import { Box, styled, Typography } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';

export default function ImageWithEditButton<T>({
  imagemPreview,
  handleChangeInput,
  prop,
  type = 'logo'
}: ImageWithEditButtonProps<T>) {
  const isCover = type === 'cover';
  return (
    <Box display={'flex'} flexDirection={'column'} alignItems={'center'}>
      <Box
        width={isCover ? '100%' : 170}
        height={170}
        padding={isCover ? 1 : 0}
        display={'flex'} justifyContent={'center'} alignItems={'center'}
        bgcolor={'#f5f5f5'}
        borderRadius={isCover ? 1 : '50%'}
        border={'1px solid #ccc'}>
          {
            !imagemPreview &&
            <Box>
              <Typography variant="subtitle2" color="gray" textAlign="center">
                Selecionar Imagem
              </Typography>
            </Box>
          }
        {
          imagemPreview &&
          <img
            src={imagemPreview}
            alt="Logo"
            style={{
              width: isCover ? '100%' : 120, height: 120,
              transform: isCover ? 'unset' : 'scale(0.9)',
              objectFit: isCover ? 'unset' : 'unset',
              borderRadius: 2,
              objectPosition: 'center bottom',
            }}
          />
        }
      </Box>
      <Box
        component={'label'}
        role={undefined}
        border={'none'}
        display="flex"
        justifyContent="center"
        alignItems="center"
        bgcolor="#1b5e20"
        width={35}
        height={35}
        borderRadius="50%"
        ml={isCover ? 68 : 12}
        mt={isCover ? -2.5 : -3.5}
        zIndex={1}
        sx={{
          alignSelf: "center",
          cursor: "pointer"
        }}
      >
        <EditIcon fontSize="small" sx={{ color: "white" }} />
        <VisuallyHiddenInput onChange={(e) => handleChangeInput(prop, e.target.files)} type="file" accept=".png, .jpg, .jpeg" />
      </Box>
    </Box>
  )
}

interface ImageWithEditButtonProps<T> {
  imagemPreview: string | null;
  handleChangeInput: (prop: keyof T, file: FileList | null) => void;
  type: 'logo' | 'cover'
  prop: keyof T
}

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});
